import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ToastsManager} from 'ng2-toastr';
import { OidcService } from '../auth/oidc.service';

@Component({
  moduleId: module.id,
  template: `<span></span>`
})
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private toast: ToastsManager,
    private oidcService: OidcService) {}

  ngOnInit() {
    this.oidcService.signoutRedirect();
    this.toast.success('Logout successful');
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/logout/logout.component.ts